module.exports = __webpack_public_path__ + "static/img/Banner.48dce97.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Leaderboard Assest/Banner.svg
// module id = t+9f
// module chunks = 1